import { useIdleTimer } from "react-idle-timer";

/**
 * Hook que gestiona la detección de inactividad del usuario.
 * Utiliza react-idle-timer para ejecutar callbacks al estar inactivo.
 * @param {Object} options - Opciones de configuración
 * @param {Function} options.onIdle - Callback cuando el usuario está inactivo
 * @param {number} [options.idleTime=1] - Minutos de inactividad antes de considerar idle
 * @param {Function} options.onPrompt - Callback de advertencia antes del idle
 * @param {number} [options.promptTime=1] - Minutos antes del idle para mostrar advertencia
 * @returns {Object} Objeto con función reset para reiniciar el temporizador
 */
export default function useIdle({ onIdle, idleTime = 1, onPrompt, promptTime = 1 }) {
  /**
   * Función que activa el prompt o adventencia de inactividad al usuario
   * Esta función se ejecuta n minutos (siendo n promptTime) antes del timeout
   */
  const handleOnPrompt = () => {
    onPrompt();
  };

  /**
   * Función que ejecuta acciones cuando el usuario cumplió el tiempo total de inactividad en la plataforma
   */
  const handleOnIdle = () => {
    onIdle();
  };

  /**
   * useIdle
   */
  const { reset } = useIdleTimer({
    timeout: 1000 * 60 * idleTime,
    promptBeforeIdle: 1000 * 60 * promptTime,
    onIdle: handleOnIdle,
    onPrompt: handleOnPrompt,
    debounce: 500,
  });

  return {
    reset,
  };
}